module.exports = __webpack_public_path__ + "img/bus.31d21fc2.png";